import { call, put } from "redux-saga/effects";
import { setNewUser, setNewClient, setNewAccount, setNewDocument } from "../../slices/register";
import { requestCheckEmailAvailability } from "../requests/register";
import { showAlert } from '../../slices/alerts';

export function* handleSetNewUser(action) {
    try {
        const { user } = action.payload;
        yield put(setNewUser(user));
    } catch (error) {
        yield put(showAlert({ severity: "error", message: "Error setting new user" }));
    }
}

export function* handleSetNewClient(action) {
    try {
        const { client } = action.payload;
        yield put(setNewClient(client));
    } catch (error) {
        yield put(showAlert({ severity: "error", message: "Error setting new client" }));
    }
}

export function* handleSetNewAccount(action) {
    try {
        const { account } = action.payload;
        yield put(setNewAccount(account));
    } catch (error) {
        yield put(showAlert({ severity: "error", message: "Error setting new account" }));
    }
}

export function* handleSetNewDocument(action) {
    try {
        const { document } = action.payload;
        yield put(setNewDocument(document));
    } catch (error) {
        yield put(showAlert({ severity: "error", message: "Error setting new document" }));
    }
}

export function* handleCheckEmailAvailability(action) {
    try {
        const { email, callback } = action.payload;
        const response = yield call(requestCheckEmailAvailability, email);
        if (callback) {
            callback(response.data.status);
        }
    } catch (error) {
        yield put(showAlert({ severity: "error", message: "Error checking email availability" }));
    }
}